import { GET_USER_GUIDE, GET_LEGAL_DOC } from 'src/constants';

// eslint-disable-next-line import/prefer-default-export
export const minSearchLetters = 3;
export const videoTutorialLink = 'https://team.effem.com/sites/ODDAPORTAL/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=gmxVUz&CID=b59d7c6d%2Db9bf%2D4c18%2D9b18%2D32434aa4dac4&FolderCTID=0x012000DD766AA27866494D9E1D006E564BE31D&id=%2Fsites%2FODDAPORTAL%2FShared%20Documents%2FContent%20%26%20Templates%2FProduct%20Assets%2FBrowse%20By%20Product%2FPPA%20Edge%2FTraining%20Collateral%2FVideos';
export const contactSupportLink = 'https://marsprod.service-now.com/sp?id=index';

export const downloadDocMappingObj = {
  tool_guide: {
    url: GET_USER_GUIDE,
    file_name: 'PPA_Analytic_Edge_UserGuide',
    file_extension: '.pdf'
  },
  legal_doc_guide: {
    url: GET_LEGAL_DOC,
    file_name:
      '2_Legal advise on Pricing Presentations and language_ SRM analitycs',
    file_extension: '.pdf'
  }
};
